module.exports = __webpack_public_path__ + "img/frame (62).bb326974.jpg";